import { RotatingLines } from "react-loader-spinner";
import styles from "./Spinner.module.css"

const Spinner = () => {
  return (
    <div className={styles.classes}>
      <RotatingLines
        strokeColor="blue"
        strokeWidth="5"
        animationDuration="0.75"
        width="96"
        visible={true}
      />
    </div>
  );
};

export default Spinner;
